var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 px-0"},[(_vm.errors.length)?_c('div',{attrs:{"id":"grouped-errors"}},[_c('div',{staticClass:"alert alert-danger"},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('ul',{},_vm._l((_vm.errors),function(error,index){return _c('li',{key:index,domProps:{"innerHTML":_vm._s(error)}})}),0)])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }